var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndoor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.125 7.458c-1.083-.75-2.333-1.166-3.667-1.166-.25 0-.5 0-.75.041a16.33 16.33 0 011.875 1.917c.209.25.292.583.292.917a1.287 1.287 0 01-.458.833c-.542.417-1.292.375-1.75-.167-.167-.208-.375-.416-.542-.625.042.375-.042.75-.333 1.042-.459.5-1.25.542-1.792.042s-1.083-.959-1.708-1.334c-1.084 1.5-1.417 3.375-1 5.167.041.083.083.167.166.25l6.292 4.458a.592.592 0 00.25.084h.042a6.366 6.366 0 004.583-2.625c2.042-2.834 1.375-6.792-1.5-8.834zM9.792 16.125c-.125.208-.084.458.125.583l.583.417-1.75 2.458c-.5.709-.333 1.667.375 2.125.708.5 1.667.334 2.125-.375L13 18.875l.583.417c.209.166.459.083.584-.125l.208-.334-4.333-3.083-.25.375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.292 5.125c2.416.833 4.5 2.292 6 4.167.125.166.416.208.583.041.167-.125.208-.416.042-.583-1.625-2-3.834-3.542-6.375-4.458-.209-.084-.459.041-.542.25-.042.25.042.5.292.583zM8.958 7.25c1.334.625 2.584 1.458 3.625 2.458a.403.403 0 00.584 0 .403.403 0 000-.583 15.116 15.116 0 00-3.834-2.583c-.208-.084-.458 0-.541.208-.125.167-.042.417.166.5zM4.917 2a2.703 2.703 0 00-2.709 2.708c0 1.5 1.209 2.75 2.709 2.75s2.708-1.208 2.708-2.75C7.667 3.208 6.417 2 4.917 2z"
  })))));
}
export default SvgIndoor;